/** Fitting a face's rows into its fixed height. */

/** The first rows that fit `max` lines: all, or `max − 1` and "+N more". */
export function fitRows<T>(
  rows: readonly T[],
  max: number,
): { shown: readonly T[]; more: number } {
  if (rows.length <= max) return { shown: rows, more: 0 };
  const shown = rows.slice(0, max - 1);
  return { shown, more: rows.length - shown.length };
}
